const postServices = {
  toastr: 'Servicio agregado',
  toastrError: 'Servicio ya registrado',
  toastrError1: 'Nombre ya registrado'
};

export default postServices;
